import { useRef } from 'react';
import ArtPortfolioComponent from './art/ArtPortfolioComponent';
import ArtHeroSection, { FIELD_RGB } from './art/ArtHeroSection';
import { galleryImages, gallerySections, instagramHandles } from './art/galleryImages';

export default function ArtPortfolio() {
  // The gallery's own jump-to-category, borrowed for the hero's heading: where a category
  // begins is measured off the tiles, so only the gallery can know it.
  const gallery = useRef(null);

  return (
    <div className="min-h-screen bg-black text-pink-500 flex flex-col items-center relative">
      {/* data-header-fill hands the header the landing photo's own navy while it is
          crossing this section — see page_assets/header. w-full because this wrapper, not
          the banner, is the flex item: the page's root is a centred column and would
          otherwise shrink-wrap the track. */}
      <div className="w-full" data-header-fill={FIELD_RGB}>
        <ArtHeroSection
          sections={gallerySections}
          onSelectSection={(index) => gallery.current?.scrollToSection(index)}
        />
      </div>

      {/* One unlabelled masonry over every piece, in category order. The boundaries are
          passed separately because nothing on the page shows them — they are what the
          radial nav steers by. */}
      <ArtPortfolioComponent
        ref={gallery}
        images={galleryImages}
        instagramHandles={instagramHandles}
        sections={gallerySections}
      />
      <div className="h-20"></div>
    </div>
  );
}
